import { api } from '../services/homphyApi';

export async function sendTokenToBackend(fcmToken: string): Promise<void> {
  await api.patch('/users/me/fcm-token', { fcmToken });
}